import { createBrowserRouter, Navigate } from "react-router";

import LogInPage from "@/app/(auth)/log-in/page";
import DashboardLayout from "@/app/dashboard/layout";
import DashboardPage from "@/app/dashboard/page";
import NotFound from "@/app/not-found";

import { routes } from "./routes";
import DaysPage from "@/app/days/page";
import RoomsPage from "@/app/rooms/page";
import LecturesPage from "@/app/lectures/page";
import ParticipantPassesPage from "@/app/participant-passes/page";
import CompaniesPage from "@/app/companies/page";
import AttendantsPage from "@/app/attendants/page";
import ContestsPage from "@/app/contests/page";
import ParticipantsPage from "@/app/participants/page";
import SessionsPage from "@/app/sessions/page";

export const router = createBrowserRouter([
  {
    path: "/404",
    element: <NotFound />,
  },

  {
    path: "/index.html",
    element: <Navigate to={`/${location.search}`} />,
  },
  {
    path: "/log-in",
    element: <LogInPage />,
  },
  {
    path: routes.home.path,
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: routes.days.path,
        element: <DaysPage />,
      },
      {
        path: routes.rooms.path,
        element: <RoomsPage />,
      },
      {
        path: routes.sessions.path,
        element: <SessionsPage />,
      },
      {
        path: routes.lectures.path,
        element: <LecturesPage />,
      },
      {
        path: routes.companies.path,
        element: <CompaniesPage />,
      },
      {
        path: routes.participantPasses.path,
        element: <ParticipantPassesPage />,
      },
      {
        path: routes.participants.path,
        element: <ParticipantsPage />,
      },
      {
        path: routes.attendants.path,
        element: <AttendantsPage />,
      },
      {
        path: routes.contests.path,
        element: <ContestsPage />,
      },
    ],
  },
]);
